import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/theme";
import { LangProvider } from "@/i18n";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Studio from "@/pages/Studio";
import Pricing from "@/pages/Pricing";
import LeadMagnet from "@/pages/LeadMagnet";
import Battle from "@/pages/Battle";
import Clips from "@/pages/Clips";
import Analytics from "@/pages/Analytics";
import Leads from "@/pages/Leads";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/live/:sid" element={<LeadMagnet />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/studio" element={<ProtectedRoute><Studio /></ProtectedRoute>} />
      <Route path="/studio/:sid" element={<ProtectedRoute><Studio /></ProtectedRoute>} />
      <Route path="/battle" element={<ProtectedRoute><Battle /></ProtectedRoute>} />
      <Route path="/clips" element={<ProtectedRoute><Clips /></ProtectedRoute>} />
      <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
      <Route path="/leads" element={<ProtectedRoute><Leads /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LangProvider>
        <AuthProvider>
          <div className="App">
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
            <Toaster position="top-right" richColors theme="dark" />
          </div>
        </AuthProvider>
      </LangProvider>
    </ThemeProvider>
  );
}

export default App;
